import React, { type FC } from 'react';
import { observer } from 'mobx-react-lite';

import { initializeMachineLogic } from './initializeMachineLogic';
import { JQueryWrapper } from '../JQueryWrapper';
import { LandingPage } from './LandingPage';
import { Pages } from '@src/Pages';
import { useUnmountReactAndNavigate } from '@src/hooks';
import { ApplicationTypes } from '@vse/machinelogic/constants/ApplicationTypes';
import { PythonApplicationEditor } from '@vse/views';
import { cleanUpReactElementsByID } from '@vse/legacy/machinelogic_react_components_support';
import type { Library, MachinelogicLibrary, ApplicationBase } from '@vse/machinelogic/types';
import { Environment } from '@vse/machinelogic/types';

interface MachineLogicProps {
  library: Library
}

export const MachineLogic: FC<MachineLogicProps> = observer(({ library }) => {
  // NOTE: we will use navigate(Page), to unmount all other components for us.
  // When everything becomes react, we can rewrite it without the navigate
  const navigate = useUnmountReactAndNavigate();

  const application = library.currentApplication;

  const navigateToLandingPage = (): void => {
    library.selectApplication(null);
    // HACK FOR PATH-FOLLOWING-VENTION-IO, replacing Pages.MACHINE_LOGIC with Pages.MACHINE_APP
    navigate(Pages.MACHINE_APP);
  };

  const onApplicationUploaded = (pApplication: ApplicationBase | null): void => {
    if (pApplication === null) {
      return;
    }
    if (pApplication.getType() === ApplicationTypes.Python) {
      cleanUpReactElementsByID('LeftPane');
      cleanUpReactElementsByID('playerControls');
    }
    library.selectApplication(pApplication);
  };

  // Landing page
  if (application === null) {
    return <LandingPage library={library} onApplicationSelected={() => { navigate(Pages.MACHINE_LOGIC); }} />;
  }

  // python
  if (application.getType() === ApplicationTypes.Python) {
    return <PythonApplicationEditor
      library={library}
      goBackToLandingPage={navigateToLandingPage}
      onApplicationUploaded={onApplicationUploaded}
      environment={Environment.PENDANT}
      showAutoSaveIndicator={true}
      showDocumentationSpan={false}
      user={undefined}
    />;
  }

  // vse
  return <JQueryWrapper executeJQueryLogic={ navigate => initializeMachineLogic({ library: library as MachinelogicLibrary, navigate, navigateToLandingPage, onApplicationUploaded }) } />;
});
